import Vue from 'vue'

export default {
  list (config = {}) {
    return Vue.http.get('/rental/dashboard', {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/rental/dashboard.js